.discord-embed {
	color: #dcddde;
	display: flex;
	font-size: 13px;
	line-height: 150%;
	margin-bottom: 2px;
	margin-top: 2px;
}

.discord-light-theme .discord-embed {
	color: #2e3338;
}

.discord-embed .discord-left-border {
	background-color: #202225;
	border-radius: 4px 0 0 4px;
	flex-shrink: 0;
	width: 4px;
}

.discord-light-theme .discord-embed .discord-left-border {
	background-color: #e3e5e8;
}

.discord-embed .discord-embed-root {
	display: grid;
	grid-auto-flow: row;
	grid-row-gap: 0.25rem;
	min-height: 0;
	min-width: 0;
	text-indent: 0;
}

.discord-embed .discord-embed-wrapper {
	background-color: #2f3136;
	max-width: 520px;
	border: 1px solid rgba(46, 48, 54, 0.6);
	border-radius: 0 4px 4px 0;
	justify-self: start;
	align-self: start;
	display: grid;
	box-sizing: border-box;
}

.discord-light-theme .discord-embed .discord-embed-wrapper {
	background-color: rgba(249, 249, 249, 0.3);
	border-color: rgba(205, 205, 205, 0.3);
}

.discord-embed .discord-embed-wrapper .discord-embed-grid {
	display: inline-grid;
	grid-template-columns: auto -webkit-min-content;
	grid-template-columns: auto min-content;
	grid-template-columns: auto;
	grid-template-rows: auto;
	padding: 0.5rem 1rem 1rem 0.75rem;
}

.discord-embed .discord-embed-thumbnail {
	border-radius: 4px;
	flex-shrink: 0;
	grid-column: 2/2;
	grid-row: 1/8;
	justify-self: end;
	margin-left: 16px;
	margin-top: 8px;
	max-height: 80px;
	max-width: 80px;
	object-fit: contain;
	object-position: top center;
}

.discord-embed .discord-embed-author {
	-webkit-box-align: center;
	align-items: center;
	color: #fff;
	font-size: 14px;
	display: flex;
	font-weight: 600;
	grid-column: 1 / 1;
	margin-top: 8px;
	min-width: 0;
}

.discord-light-theme .discord-embed .discord-embed-author {
	color: #4f545c;
}

.discord-embed .discord-embed-author a {
	color: #fff;
	font-weight: 600;
}

.discord-light-theme .discord-embed .discord-embed-author a {
	color: #4f545c;
}

.discord-embed .discord-embed-author .discord-author-image {
	border-radius: 50%;
	height: 24px;
	margin-right: 8px;
	width: 24px;
}

.discord-embed .discord-embed-provider {
	font-size: 0.75rem;
	line-height: 1rem;
	font-weight: 400;
	grid-column: 1/1;
	margin-top: 8px;
	unicode-bidi: plaintext;
	text-align: left;
}

.discord-light-theme .discord-embed .discord-embed-provider {
	color: #4f545c;
}

.discord-embed .discord-embed-title {
	-webkit-box-align: center;
	align-items: center;
	color: #fff;
	display: inline-block;
	font-size: 1rem;
	font-weight: 600;
	grid-column: 1 / 1;
	margin-top: 8px;
	min-width: 0;
}

.discord-embed .discord-embed-title a {
	color: #00aff4;
	font-weight: 600;
}

.discord-embed .discord-embed-image {
	border-radius: 4px;
	max-width: 100%;
}

.discord-embed .discord-embed-media {
	border-radius: 4px;
	contain: paint;
	display: block;
	grid-column: 1/1;
	margin-top: 16px;
}

.discord-embed .discord-embed-media.discord-embed-media-video {
	height: 225px;
}

.discord-embed .discord-embed.media .discord-embed-image {
	overflow: hidden;
	position: relative;
	user-select: text;
}

.discord-embed .discord-embed-media .discord-embed-video {
	-webkit-box-align: center;
	-webkit-box-pack: center;
	align-items: center;
	border-radius: 0;
	cursor: pointer;
	display: flex;
	height: 100%;
	justify-content: center;
	max-height: 100%;
	width: 100%;

	width: 400px;
	height: 225px;
	left: 0px;
	top: 0px;
}

.discord-embed-custom-emoji {
	display: inline-block;
}

.discord-embed-custom-emoji .discord-embed-custom-emoji-image {
	width: 18px;
	height: 18px;
	vertical-align: bottom;
}
